import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Owners_ds_get_assigned_containerService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId?: number, projectId?: number, containerTypeId?: number }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, OwnerId?: number, ProjectId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_assigned_container/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerId?: number, projectId?: number, containerTypeId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, OwnerId?: number, ProjectId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_assigned_container/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerId?: number, projectId?: number, containerTypeId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, OwnerId?: number, ProjectId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_assigned_container/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerId?: number, projectId?: number, containerTypeId?: number    }) {
      return false;
    }
}
